import { ScrollArea, Stack } from '@mantine/core'
import React from 'react'

import UserDetails from '@/components/Details/UserDetails/UserDetails'

import classes from './MembersList.module.css'

interface MembersListProps {
  members: string[]
}

const MembersList: React.FC<MembersListProps> = ({ members }) => (
  <ScrollArea h="500px">
    <Stack gap="10px" style={{ marginTop: '2px' }}>
      {members.map(member => (
        <Stack key={member} className={classes.member}>
          <UserDetails userId={member} />
        </Stack>
      ))}
    </Stack>
  </ScrollArea>
)

export default MembersList
